import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import { breakpoints } from '@/css/resources/variables.css';
import {
	grid,
	resetFirstLastChildMargins,
	resetFirstLastMargins,
} from '@/css/resources/placeholders.css';
import {
	fontStyle,
	fluidPadding,
	fluidBorderWidth,
} from '@/css/resources/mixins.css';

const getDynamicStyles = (styles) =>
	cssObj(fluidBorderWidth(styles?.border?.width), {
		background: styles?.backgroundColor,
		borderColor: styles?.border?.color,
		'.supt-pageHeaderTwoColumns__inner': cssObj(
			fluidPadding(styles?.padding),
			{
				'.supt-pageHeaderTwoColumns__title': cssObj(
					fontStyle(
						{
							...styles?.title?.typography,
							textAlign: styles?.title?.textAlignment,
							color: styles?.title?.color,
						},
						false
					),
					{
						marginBottom: styles?.title?.typography?.margin?.bottom,
					}
				),
				'.supt-pageHeaderTwoColumns__introduction': fontStyle({
					...styles?.introduction?.typography,
					textAlign: styles?.introduction?.textAlignment,
					color: styles?.introduction?.color,
				}),

				'.supt-pageHeaderTwoColumns__content': {
					'.supt-paragraph, .supt-list': fontStyle({
						...styles?.text?.typography,
						textAlign: styles?.text?.textAlignment,
						color: styles?.text?.color,
					}),
				},
			}
		),
	});

const getStyles = (styles) =>
	css(getDynamicStyles(styles), {
		position: 'relative',
		borderStyle: 'solid',

		/* @media (min-width: $main-breakpoint) {
		padding-top: 53%;
		height: 0;
		overflow: hidden;
	} */

		'.supt-pageHeaderTwoColumns__inner': cssObj(grid, {
			position: 'relative',
			alignContent: 'center',
			zIndex: 1,

			'& > *': {
				gridColumn: '1/12',

				[`@media (min-width: ${breakpoints.tablet})`]: {
					gridColumnEnd: '12',
				},

				[`@media (min-width: ${breakpoints.medium})`]: {
					gridColumnEnd: '11',
				},

				[`@media (min-width: ${breakpoints.laptop})`]: {
					gridColumnEnd: '10',
				},

				[`@media (min-width: ${breakpoints.desktop})`]: {
					gridColumnStart: '1',
					gridColumnEnd: '6',
				},
			},

			'.supt-pageHeaderTwoColumns__introduction': resetFirstLastMargins,

			'.supt-pageHeaderTwoColumns__content': resetFirstLastChildMargins,
		}),

		'.supt-pageHeaderTwoColumns__backgroundImage, .supt-pageHeaderTwoColumns__backgroundImageLandscape':
			{
				pointerEvents: 'none',
			},

		/* image
	   - on mobile, show the square image
		 - on tablet, show the landscape image to avoid taking too much height in the page
		 - on laptop, show the square image in the right column
	 */

		[`@media (max-width: calc(${breakpoints.tablet} - 1px))`]: {
			'.supt-pageHeaderTwoColumns__backgroundImageLandscape': {
				display: 'none',
			},
		},

		[`@media (min-width: ${breakpoints.tablet}) and (max-width: calc(${breakpoints.desktop} - 1px))`]:
			{
				'.supt-pageHeaderTwoColumns__backgroundImage': {
					display: 'none',
				},
			},

		[`@media (min-width: ${breakpoints.desktop})`]: {
			'.supt-pageHeaderTwoColumns__backgroundImageLandscape': {
				display: 'none',
			},
			'.supt-pageHeaderTwoColumns__backgroundImage': {
				position: 'absolute',
				top: 0,
				right: 0,
				height: '100%',
				width: '50%',
				zIndex: 0,
				/* TODO: fix these hacks — maybe with the use of <picture> to load only 1 image, and `layout="fill"` on the <Image> to make sure we are future-proof? */

				'*': {
					height: '100%',
					paddingBottom: '0 !important',
				},

				img: {
					display: 'block',
					height: '100%',
					width: '100%',
					objectFit: 'cover',
					objectPosition: 'right center',
					pointerEvents: 'none',
				},
			},
		},
	});

const getEditStyles = () =>
	css({
		maxWidth: 'none !important',

		'textarea, ::placeholder': {
			fontWeight: 'bold',
			background: 'none',
			color: 'inherit',
		},

		'.supt-pageHeaderTwoColumns__backgroundImage': {
			margin: 0,
		},
	});

export { getStyles, getEditStyles };
